import Service from '@/service/index.js';
export default {
  components: {
  },
  data () {
    return {
      pageNum: 1,
      pageSize: 9,
      total: 0,
      tabActiveType: '1',
      newsSecondTag: [],
      active: 0,
      newsList: [],
      partId: 1,
      news1: {},
      createdTimeDay: '',
      createdTimeYear: '',
      isPortal: true,
      showDialog: false
    };
  },
  created () {
    const obj = {
      NEWS_SECOND_TAG: 'newsSecondTag'
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = [{ code: null, value: '全部' }, ...res.data];
        }
      });
    });
    this.getNewsList();
  },
  methods: {
    toTarget(url) {
      if (window.location.href.indexOf('gxcqjyzx.cn') >= 0) {
        window.open('https://' + url + '.gxcqjyzx.cn', '_blank');
        return;
      }
      if (window.location.href.indexOf('gxcqjyzx.com') >= 0) {
        window.open('https://' + url + '.gxcqjyzx.com', '_blank');
        return;
      }
    },
    // formate日期
    getCreatedTimeDay (date) {
      const baseDateFilter = this.$options.filters['baseDate'];
      const baseDate = baseDateFilter(date);
      return baseDate.substring(8, 10);
    },
    goNewsList () {
      this.$router.push('/news/news-list/1');
    },
    toShowDialog() {
      this.$emit('download');
    },
    getCreatedTimeYear (date) {
      const baseDateFilter = this.$options.filters['baseDate'];
      const baseDate = baseDateFilter(date);
      return baseDate.substring(0, 7);
    },
    chooseMenu (code, index) {
      this.partId = code;
      this.active = index;
      this.getNewsList();
    },
    getNewsList () {
      this.newsList = [];
      this.total = 0;
      const params = { type: 1, partId: this.partId, isPortal: this.isPortal, pageNum: this.pageNum, pageSize: this.pageSize };
      Service.getNewsList(params).then(res => {
        if (res && res.code === '0') {
          this.total = res.data.total;
          this.newsList = res.data.list && res.data.list.slice(1);
          // console.log( this.newsList,'12121');
          this.news1 = res.data.list && res.data.list[0] || {};
        }
      });
    },
    // 详情
    toDetailPage (id) {
      this.$router.push({
        path: '/news/news-detail',
        query: {
          id: id
        }
      });
    },
    // 跳转
    toJump(url) {
      window.open(url, '_blank'); // 使用 _blank 打开新标签页
    }
  }
};
